import { useState } from "react"
import { Link } from "react-router-dom"
import './FirmwaresList.scss'

export default function List({ id, details, ...p }) {
    return (
        <div className="listfirmware">
            <p>{id}</p>
            <p>{p.device_type}</p>
            <p>{p.hw_version}</p>
            <p>{p.sw_version}</p>
            <p>{p.release_date}</p>
        </div>
    )
}
